/**
 * RulebookShortcut — the book icon that appears in the shared page
 * header, deep-linking to this page's node in the Rulebook App Map.
 *
 * Usage:
 *   <RulebookShortcut nodeId="projects.inside.tools.plan-room" />
 *
 * Clicking navigates to /admin/rulebook?tab=app-map&node=<id>. The
 * Rulebook expands the tree, selects the node, and shows its detail
 * pane (description + feature xrefs + per-page Fixes & Additions).
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BookMarked } from 'lucide-react';

export default function RulebookShortcut({ nodeId, className = '', size = 'sm' }) {
  const navigate = useNavigate();
  if (!nodeId) return null;
  const px = size === 'lg' ? 'p-2' : 'p-1.5';
  const iconSize = size === 'lg' ? 'w-5 h-5' : 'w-4 h-4';
  return (
    <button
      type="button"
      onClick={() => navigate(`/admin/rulebook?tab=app-map&node=${encodeURIComponent(nodeId)}`)}
      className={`inline-flex items-center justify-center ${px} rounded-md border border-stone-300 bg-white/80 hover:bg-amber-50 hover:border-amber-300 text-stone-700 hover:text-amber-800 transition-colors ${className}`}
      title="Explain this screen (open the Rulebook)"
      aria-label="Explain this screen (Rulebook)"
      data-testid={`rulebook-shortcut-${nodeId}`}
    >
      <BookMarked className={iconSize} />
    </button>
  );
}
